import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  containerIcon: {
    height: 44,
    width: 44,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    fontSize: '27px',
    color: '#263057'
  }
}))

export default useStyles
